import { enableProdMode } from '@angular/core';
import { PathLocationStrategy } from '@angular/common';

import { environment } from 'environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from '@finder/app.component';
import { appConfig } from '@finder/app.config';

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, appConfig)
    .catch(err => console.log(err));

// platformBrowserDynamic().bootstrapModule(AppModule)
//     .catch(err => console.log(err));

// eslint-disable-next-line @typescript-eslint/naming-convention
const _orig_prepareExternalUrl = PathLocationStrategy.prototype.prepareExternalUrl;
